import _ from 'lodash'
import Vue from 'vue'
import anime from 'animejs'
import './Header.scss'

export default {
    name: 'Header',

    data: {
        interactions: true,
        mobileMenuOpen: false
    },

    mounted () {
        _.each(this.$refs.mobileMenu.querySelectorAll('a'), a => {
            a.addEventListener('click', e => {
                const subMenu = a.parentNode.querySelector('ul.sub-menu')
                if (subMenu) {
                    e.preventDefault()
                    this.toggleList(subMenu, true)
                }
            })
        })
    },

    methods: {
        toggleMobileMenu () {
            if (!this.interactions) {
                return
            }

            this.mobileMenuOpen = !this.mobileMenuOpen
            this.toggleList(this.$refs.mobileMenu.querySelector('ul.menu'))
        },

        toggleList (ul, isSub = false) {
            this.interactions = false

            if (isSub) {
                this.$refs.mobileMenu.querySelector('ul.menu').style.height = 'auto'
            }

            if (ul.offsetHeight === 0) {
                if (isSub) {
                    ul.style.height = 'auto'
                }

                // open menu
                Vue.nextTick(() => {
                    anime({
                        targets: ul,
                        height: [0, ul.offsetHeight],
                        duration: 1000,
                        easing: 'easeInOutQuint',
                        complete: () => {
                            this.interactions = true
                            // ul.style.height = null
                        }
                    })
                })
            } else {
                // close menu
                anime({
                    targets: ul,
                    height: 0,
                    duration: 1000,
                    easing: 'easeInOutQuint',
                    complete: () => {
                        this.interactions = true
                        ul.style.height = null
                    }
                })
            }
        }
    }
}


// WEBPACK FOOTER //
// ./mtwp/Theme/Components/Header/Header.js